import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-ship-station',
  templateUrl: './footer-ship-station.component.html',
  styleUrls: ['./footer-ship-station.component.scss'],
})
export class FooterShipStationComponent implements OnInit {
  @Input() show_btn:boolean=false;

  constructor() { }

  ngOnInit() {}
  scrollTo(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (elementId==='tracking-input'){
        console.log('tracking-input')
      }
    }
  }

}
